import './ShareDialog.less';
import React, {useState, useEffect} from 'react';
import routes from "../../../routing/routes";
import Button from "../../../../bootstrap/components/button/Button";
import __ from "../../../i18n";
import {copyToClipboard} from "../../../../bootstrap/utils/browser";
import Toasts, {TOAST_ERROR, TOAST_SUCCESS} from "../../../../bootstrap/scomponents/toasts/Toasts";
import Icon from "../../../../bootstrap/components/icon/Icon";
import getAbsoluteUrl from "../../../routing/getAbsoluteUrl";
import externalLinks from "../../../routing/externalLinks";


export default function ShareDialog({course}) {

    const sharedUrl = getAbsoluteUrl(routes.course.getUrl(course.slug));

    return <div className="share-dialog">
        <div className="url-block">
            <input type="text" value={sharedUrl}/>
            <button
                type="button"
                onClick={() => {
                    copyToClipboard(sharedUrl, () => {
                        Toasts.add(TOAST_SUCCESS, __('Copied to clipboard'));
                    }, (errorMessage) => {
                        Toasts.add(TOAST_ERROR, errorMessage);
                    });
                }}
            >
                {__('Copy')}
            </button>
        </div>
        <div className="socials">
            <a
                href={externalLinks.share_facebook(sharedUrl, course.name)}
                target="_blank"
            >
                <Icon name="facebook-f"/>
            </a>
            <a
                href={externalLinks.share_twitter(sharedUrl, course.name)}
                target="_blank"
            >
                <Icon name="twitter"/>
            </a>
            <a
                href={externalLinks.share_linkedin(sharedUrl, course.name)}
                target="_blank"
            >
                <Icon name="linkedin-in"/>
            </a>
        </div>
    </div>;
}
